export default __webpack_public_path__ + "static/media/enrolment-envelope-icon.219962c4.svg";